import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { AuthShell } from "@/components/AuthShell";
import { Field, inputCls } from "@/components/kit";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const SPORTS = ["Football", "Rugby", "Hurling", "Gaelic Football", "Cricket", "Hockey", "Netball", "Basketball", "Volleyball", "Other"];

export default function Signup() {
  const [params] = useSearchParams();
  const planId = params.get("plan");
  const interval = params.get("interval") || "month";
  const [f, setF] = useState({ team_name: "", sport: "Football", location: "", name: "", email: "", password: "", code: params.get("code") || "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const { setUser } = useAuth();
  const nav = useNavigate();
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/signup-team", f);
      setUser(data.user);
      if (planId) {
        try {
          const r = await api.post(`/teams/${data.team.id}/billing/checkout`, { plan_id: planId, interval, origin_url: window.location.origin });
          window.location.href = r.data.checkout_url;
          return;
        } catch { /* fall through to dashboard billing tab */ }
        nav(`/manage/${data.team.id}?tab=billing`, { replace: true });
        return;
      }
      nav(`/manage/${data.team.id}`, { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Register your team"
      subtitle="Your club workspace and fan hub go live straight away."
      footer={<>Already on SportsDiary? <Link to="/login" className="font-semibold text-[#CCFF00]" data-testid="signup-login-link">Log in</Link></>}
    >
      <form onSubmit={submit} className="space-y-4" data-testid="signup-form">
        <Field label="Team name"><Input required value={f.team_name} onChange={set("team_name")} placeholder="e.g. Riverside Rovers FC" data-testid="signup-team-name-input" /></Field>
        <div className="grid grid-cols-2 gap-4">
          <Field label="Sport">
            <select className={inputCls} value={f.sport} onChange={set("sport")} data-testid="signup-sport-select">
              {SPORTS.map((s) => <option key={s}>{s}</option>)}
            </select>
          </Field>
          <Field label="Town / ground"><Input value={f.location} onChange={set("location")} data-testid="signup-location-input" /></Field>
        </div>
        <Field label="Your name"><Input required value={f.name} onChange={set("name")} data-testid="signup-name-input" /></Field>
        <Field label="Email"><Input type="email" required value={f.email} onChange={set("email")} data-testid="signup-email-input" /></Field>
        <Field label="Password" hint="At least 8 characters"><Input type="password" required minLength={8} value={f.password} onChange={set("password")} data-testid="signup-password-input" /></Field>
        <Field label="Partner / coupon code (optional)"><Input value={f.code} onChange={set("code")} data-testid="signup-code-input" /></Field>
        {error && <p className="text-sm text-rose-400" data-testid="signup-error">{error}</p>}
        <Button type="submit" disabled={busy} className="h-11 w-full rounded-full font-bold uppercase tracking-wider" data-testid="signup-submit-btn">
          {busy ? "Creating team…" : planId ? "Create team & continue to payment" : "Create my team"}
        </Button>
      </form>
    </AuthShell>
  );
}
